import { ApplicationState, TosUpdatedDatesStatus } from './types';

export const INITIAL_STATE: ApplicationState = {
  tosUpdatedDates: {
    status: TosUpdatedDatesStatus.NotLoaded,
    dates: null,
  },
  tosNextUpdateDates: {
    status: TosUpdatedDatesStatus.NotLoaded,
    dates: null,
  },
};
